<template>
  <div class="cards-content">
    <fcwpSidebarCard
      v-for="(item, index) of content"
      :key="index"
      class="card"
      :class="item.data && item.data.image_url ? 'card-big' : 'card-small'"
      :card="item.data"
    ></fcwpSidebarCard>
  </div>
</template>

<script>
import fcwpSidebarCard from "./fcwpSidebarCard.vue";

export default {
  name: "fcwpSidebarContent",
  props: ["content"],
  components: {
    fcwpSidebarCard
  }
};
</script>

<style lang="scss">

.cards-content {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(auto-fill, 450px);
  margin: 3vw 0vw;

  .current {
    .card-details p {
      font-weight: 400;
      color: rgb($secondary-color);
    }
  }

  .unavailable {
    .card-title h3 {
      color: rgba($quinary-color, 0.7);
    }
    .card-links {
      display: none;
    }
  }

}


.card {
  border: solid 10px rgb($quaternary-color);
  background: rgb($tertiary-color);
  overflow: hidden;
  p {
    margin: 0;
  }
}

.card-small {
  grid-row: auto / span 1;
  min-height: 450px;
}

.card-big,
.card-full {
  grid-row: auto / span 2;
  padding-bottom: 70px;
  min-height: 930px;

}

@media (max-width: 1199.98px) {
  .cards-content {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767.98px) {
  .cards-content {
    grid-template-columns: repeat(1, 1fr);
  }
  .cards-content .card-small,
  .cards-content .card-big,
  .cards-content .card-full {
    min-height: initial;
    padding: 0;
  }

}

@media (max-width: 350px) {
  .sidebar-content {
    margin: 5vw 1vw;
  }
}

.home-item {
  background: rgb($quaternary-color);
}

</style>